<template>
	<div>
		<van-nav-bar
				:title="barData.title"
				:left-text="barData.leftText"
				:left-arrow="barData.leftArrow"
				@click-left="$emit('handleLeft')"
		></van-nav-bar>
		<!--<div class="logo">
		</div>-->
	</div>
</template>

<script>
export default {
  props: ['barData'],
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
	/*.van-hairline--bottom::after {*/
		/*border: none;*/
	/*}*/
	/*.logo {
		width: 100%;
		height: 80px;
		background: #f85415 url(../assets/bannerBg.png) no-repeat center bottom;
		-webkit-background-size: contain;
		background-size: contain;
		font-size: 0;
	}*/
</style>
